import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { axios } from '@/src/lib/axios/axios';
import { RootState } from '@/src/reducers/types';

// Hook prior to project details react-query integration
export const useProjectDetails = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const project = useSelector((store: RootState) => store.project.Selected);
  const dispatch = useDispatch();

  useEffect(() => {
    const url = `/api/project/detail/${projectId}?info=${1}`;
    axios(url).then((responseProject) => {
      if (responseProject) {
        dispatch({ type: 'SET_PROJECT_SELECTED', Selected: responseProject });
      }
    });
  }, [projectId, dispatch]);

  return { project };
};
